import React from 'react';
import MosqueForm from './MosqueForm';
import { useNavigate, useParams } from 'react-router-dom';
import useUpload from 'hooks/useUpload';
import ContactForm from '../school/ContactForm';
import { useMosque, useUpdateMosque } from 'hooks/useBeneficiaries';

function EditMosque() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { upload, loading: uploadLoading } = useUpload();

  const { mosque } = useMosque(id);
  const { updateMosqueAsync, isUpdating } = useUpdateMosque();

  // TODO: Contact data and mutations need to be migrated to Supabase
  const contactData = null;
  const updateContactLoading = false;
  const insertContactLoading = false;

  const submitEditMosque = async data => {
    try {
      if (data.document && typeof data.document !== 'string') {
        data.document = await upload(data.document);
      }

      await updateMosqueAsync({ id, data });
      navigate(`/mosque/${id}/details`);
    } catch (error) {
      console.error('Error updating mosque:', error);
    }
  };

  const submitContact = values => {
    // TODO: Implement contact update/create when migrated to Supabase
    console.log('Contact submission not yet implemented for Supabase', values);
  };

  return (
    <>
      <MosqueForm
        onSubmit={submitEditMosque}
        loading={isUpdating || uploadLoading}
        initValues={mosque || {}}
      />

      <ContactForm
        initValues={contactData?.contact}
        onSubmit={submitContact}
        loading={updateContactLoading || insertContactLoading}
      />
    </>
  );
}

export default EditMosque;
